<template>
  <base-dialog
      :visible="show"
      title="创建工单"
      width="1200px"
      @close="handlerClose"
  >
    <div>
      <el-form
        ref="form"
        label-width="100px"
      >
        <el-form-item label="标题">
          <el-input
            v-model="payload.title"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            v-model="payload.content"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6}"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
              ref="upload"
              :action="config.baseApi + '/business/upload/default'"
              :limit="5"
              accept=".jpg, .jpeg, .bmp, .png, .gif,
               .txt, .log, .ini, .conf,
               .rar, .zip,
               .doc, .docx,
               .pdf,
               .xlsx, .xls,
               .eml,
               image/jpeg, image/bmp, image/png, image/gif,
               text/plain,
               application/zip, application/vnd.rar,
               application/msword,
               application/vnd.openxmlformats-officedocument.wordprocessingml.document,
               application/pdf,
               application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
               application/vnd.ms-excel,
               message/rfc822"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :on-error="handleError"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">最多支持5个附件。</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/baseDialog/baseDialog.vue";
import config from "@/assets/js/conf/config";
import {mapActions} from "vuex";

export default {
  computed: {
    config() {
      return config
    }
  },
  components:{
    BaseDialog
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      show: false,
      payload:{
        title: '',
        content: ''
      },
      fileList: [],
    }
  },
  watch:{
    visible(val) {
      this.show = val;
    },
  },
  methods: {
    ...mapActions({
      getWorkOrderList: "ucenter/getWorkOrderList",
      getWorkOrderDetail: "ucenter/getWorkOrderDetail",
      opCreateWorkOrder: "ucenter/opCreateWorkOrder",
      opReplyWorkOrder: "ucenter/opReplyWorkOrder",
      opFinishWorkOrder: "ucenter/opFinishWorkOrder",
    }),
    handlerClose(){
      this.show = false;
      this.$emit('update:visible', false);
      this.$emit('close')
      this.handlerClearForm();
    },
    submit(){
      if(this.payload.title.length < 1){
        this.$message.warning('请输入标题')
        return;
      }
      if(this.payload.content.length < 1 && this.fileList.length < 1){
        this.$message.warning('请输入内容或上传附件！')
        return;
      }

      const payload = Object.assign(this.payload, {files: []});

      this.fileList.map(item=>{
        payload.files.push(item.url)
      })
      payload.files = payload.files.join(',')

      this.opCreateWorkOrder({
        data: payload,
        success: (res) => {
          if(res.code===200){
            this.$message({message: res.msg,type: 'success',});
            this.handlerClose()
          } else {
            this.$message({message: res.msg,type: 'error',});
          }
        }
      })
    },
    handleError(err, file) {
      this.$message.error(`${file.name} 上传失败：${err.message}`)
      // 自动移除失败项（2.15版本需手动处理）
      setTimeout(() => {
        const index = this.$refs.upload.uploadFiles.findIndex(f => f.uid === file.uid)
        if(index > -1) {
          this.$refs.upload.uploadFiles.splice(index, 1)
        }
      }, 2000)
    },
    handleSuccess(res, file){
      if (res.status === 200){
        this.fileList.push(res.data)
      }else{
        this.$message('上传失败！');
        const index = this.$refs.upload.uploadFiles.findIndex(f => f.uid === file.uid)
        this.$refs.upload.uploadFiles.splice(index, 1);
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handlerClearForm(){
      this.payload.title = ''
      this.payload.content = '';
      this.fileList = [];
    },
  }
}
</script>

<style scoped>

</style>